// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"AdminThirdPartyManagement_tabContainer_7C4sp"};